export const LOGO = "/assets/logo-circle.png";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1535571393765-ea44927160be?auto=format&fit=crop&w=1200&q=80",
  heroAlt: "/assets/reel-2.jpg",
  portrait: "/assets/yogyata-portrait.jpg",
  clinical: "https://images.unsplash.com/photo-1659353888906-adb3e0041693?auto=format&fit=crop&w=900&q=80",
  breastfeeding: "https://images.unsplash.com/photo-1634290996327-099de799f602?auto=format&fit=crop&w=900&q=80",
  podcast: "https://images.unsplash.com/photo-1619490287893-862fd1808407?auto=format&fit=crop&w=900&q=80",
};

export const REELS = [
  { img: "/assets/reel-1.jpg", caption: "Classes of the month — swipe for calendar" },
  { img: "/assets/reel-2.jpg", caption: "Meet your IBCLC — founder of The Birth Life" },
  { img: "/assets/reel-3.jpg", caption: "Evidence Based Birth Podcast · EBB 402" },
  { img: "/assets/reel-4.jpg", caption: "Common latching mistakes to avoid" },
  { img: "/assets/reel-5.jpg", caption: "Week 1 back at work — supply drop" },
  { img: "/assets/reel-6.jpg", caption: "Feeding & positioning tips for new moms" },
];

export const STATS = [
  { value: "300K+", label: "Instagram community", testid: "stat-instagram" },
  { value: "20,000+", label: "Families supported", testid: "stat-families" },
  { value: "15+", label: "Years of clinical experience", testid: "stat-years" },
  { value: "10+", label: "Mother-baby pairs daily at CK Birla", testid: "stat-rounds" },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "A rare intersection",
    body: "The only clinician in India bringing together physiotherapy assessment, lactation science, and deep roots in Indian feeding culture — applied to every mother and baby she sees.",
  },
  {
    num: "02",
    title: "Inside the hospital, every morning",
    body: "Morning lactation rounds at CK Birla Hospital's IPD and OPD, supporting 10+ mother-baby pairs every single day — plus international consults with NRI families in the US, UK and Australia.",
  },
  {
    num: "03",
    title: "Heard around the world",
    body: "Featured on the Evidence Based Birth Podcast, Episode 402 — speaking on the cultural dimensions of lactation and infant feeding in India.",
  },
];

export const SERVICES = [
  {
    id: "lactation",
    title: "Lactation Consultation",
    desc: "Pre & postnatal feeding assessments — latch, pain, supply, tongue-tie screening and a written care plan.",
    duration: "60 min",
    price: "₹2,500",
    mode: "In-clinic Gurgaon · Online worldwide",
    testid: "service-lactation",
  },
  {
    id: "birth-ed",
    title: "Childbirth Education",
    desc: "Small-group and private birth prep classes covering labour, comfort measures and the first golden hour.",
    duration: "4 sessions",
    price: "₹6,000",
    mode: "Weekend cohorts · Online",
    testid: "service-birth-ed",
  },
  {
    id: "solids",
    title: "Infant Feeding & Solids",
    desc: "Starting solids with confidence — textures, gagging vs choking, culturally grounded Indian weaning foods.",
    duration: "45 min",
    price: "₹1,800",
    mode: "Online worldwide",
    testid: "service-solids",
  },
];

export const COURSES = [
  {
    id: "bf-masterclass",
    title: "The Ultimate Breastfeeding Masterclass",
    tagline: "From first latch to confident feeding",
    modules: 8,
    hours: "6.5 hrs",
    price: "₹4,999",
    testid: "course-bf-masterclass",
  },
  {
    id: "birth-prep",
    title: "Gentle Birth Prep Intensive",
    tagline: "Labour, breath & the golden hour",
    modules: 6,
    hours: "4 hrs",
    price: "₹3,499",
    testid: "course-birth-prep",
  },
  {
    id: "solids-course",
    title: "Solid Foods & Latch Healing",
    tagline: "Weaning the Indian way, backed by science",
    modules: 5,
    hours: "3 hrs",
    price: "₹2,499",
    testid: "course-solids",
  },
];

export const TIME_SLOTS = ["09:00", "10:30", "12:00", "14:00", "15:30", "17:00"];

export const TESTIMONIALS = [
  {
    quote:
      "Thank you so much ma'am for being a positive influence on our lives. So many questions answered so peacefully — the solids journey became easier and so did my life as a mom.",
    name: "Vidhi",
    tag: "Solids guidance · Verified mother",
  },
  {
    quote:
      "After three weeks of painful feeding, one session with Yogyata changed everything. She saw what three other consultations missed.",
    name: "Ananya S.",
    tag: "Lactation consult · Gurgaon",
  },
  {
    quote:
      "As an NRI mom in London, her online consults felt like family. Evidence-based but so rooted in our culture — a combination I couldn't find anywhere else.",
    name: "Priya R.",
    tag: "Online consult · UK",
  },
  {
    quote:
      "Her birth prep classes gave my husband and me a calm we didn't know was possible. We walked into labour informed, not afraid.",
    name: "Meghna & Arjun",
    tag: "Birth education · Cohort 12",
  },
];

export const MARQUEE_ITEMS = [
  "Evidence-based care",
  "IBCLC certified",
  "Culturally grounded",
  "20,000+ families",
  "CK Birla Hospital",
  "Gurgaon · Worldwide",
  "Birth to weaning",
];
